import { Box, Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormNumberField from '../../../FormFields/FormNumberField';
import FormTitle from '../../../FormFields/FormTitle';
import { CLINICAL_REIMBURSEMENT } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';

CensusBreakdownForm.propTypes = {
  permissions: PropTypes.object,
};

export default function CensusBreakdownForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    CLINICAL_REIMBURSEMENT.MEDICARE_CENSUS_COUNT.id,
    CLINICAL_REIMBURSEMENT.MEDICAID_CENSUS_COUNT.id,
    CLINICAL_REIMBURSEMENT.MANAGED_CARE_CENSUS_COUNT.id,
    CLINICAL_REIMBURSEMENT.PRIVATE_PAY_CENSUS_COUNT.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  const numberFields = [
    {
      id: CLINICAL_REIMBURSEMENT.MEDICARE_CENSUS_COUNT.id,
      fieldName: CLINICAL_REIMBURSEMENT.MEDICARE_CENSUS_COUNT.fieldName,
      label: 'Medicare',
    },
    {
      id: CLINICAL_REIMBURSEMENT.MEDICAID_CENSUS_COUNT.id,
      fieldName: CLINICAL_REIMBURSEMENT.MEDICAID_CENSUS_COUNT.fieldName,
      label: 'Medicaid',
    },
    {
      id: CLINICAL_REIMBURSEMENT.MANAGED_CARE_CENSUS_COUNT.id,
      fieldName: CLINICAL_REIMBURSEMENT.MANAGED_CARE_CENSUS_COUNT.fieldName,
      label: 'Managed care',
    },
    {
      id: CLINICAL_REIMBURSEMENT.PRIVATE_PAY_CENSUS_COUNT.id,
      fieldName: CLINICAL_REIMBURSEMENT.PRIVATE_PAY_CENSUS_COUNT.fieldName,
      label: 'Private pay',
    },
  ];

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Census Broken Down By:
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {numberFields.map((field) =>
            field.id in permissions ? (
              <Grid item xs={12} sm={3} key={field.id}>
                <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                  <FormTitle fieldAttributes={{ questionTitle: field.label }} />
                  <FormNumberField
                    fieldName={field.fieldName}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                    fieldAttributes={{
                      isEditable: permissions[field.id],
                    }}
                  />
                </Box>
              </Grid>
            ) : null
          )}
        </Grid>
      </Card>
    )
  );
}
